import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.reduce.js";
import { AxiosInstance } from "./vuexConfig";
import router from "../router";
import { apiRequestStringifier, getFormData, getType, isObject, serializeObject } from "@/assets/js/mcn-helpers";
import i18n from "../plugins/vueI18n";
import store from "./index";
import { Response } from "@/views/dashboard/models/Response";
import JsonMapper from "../assets/js/models/helpers/JsonMapper";
import JsonArrayMapper from "../assets/js/models/helpers/JsonArrayMapper";
const sendApiRequest = function (context) {
  try {
    var _i18n$locale;
    let {
      method,
      uri,
      data,
      headers,
      contentType,
      onUploadProgress,
      onDownloadProgress,
      baseURL,
      timeout,
      serialize = true
    } = context;
    let AxiosConfig = {
      method,
      url: uri,
      data: Object.assign({}, AxiosInstance.defaults.data, data),
      headers: Object.assign({}, AxiosInstance.defaults.headers, headers),
      params: {
        lang: (_i18n$locale = i18n.locale) !== null && _i18n$locale !== void 0 ? _i18n$locale : 'en',
        time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }
    };
    if (contentType === 'form-data' && AxiosConfig) {
      AxiosConfig.headers['content-type'] = 'multipart/form-data';
      const form_data = new FormData();
      if (!Array.isArray(data) && isObject(data)) data = getFormData(data);
      if (Array.isArray(data)) {
        data.forEach(field => {
          Array.isArray(field.value) ? field.value.length > 0 ? field.value.forEach(sv => form_data.append(`${field.name}[]`, sv)) : form_data.append(`${field.name}[]`, field.value) : form_data.append(field.name, field.value);
        });
      }
      if (AxiosConfig.method === 'PUT') {
        form_data.append('_method', AxiosConfig.method);
        AxiosConfig.method = 'POST';
      }
      AxiosConfig.data = form_data;
    } else if (serialize !== false) {
      AxiosConfig.data = Array.isArray(data) ? data.map(i => JSON.stringify(i, apiRequestStringifier)).reduce((pi, i) => Object.assign(pi, JSON.parse(i)), {}) : JSON.stringify(data, apiRequestStringifier);
    }
    if (onUploadProgress) AxiosConfig.onUploadProgress = onUploadProgress;
    if (onDownloadProgress) AxiosConfig.onDownloadProgress = onDownloadProgress;
    if (baseURL) AxiosConfig.baseURL = baseURL;
    if (timeout) AxiosConfig.timeout = timeout;
    return new ResponseManager(AxiosInstance(AxiosConfig), context);
  } catch (e) {
    console.log('Error', e);
  }
};
function ResponseManager(httpClient, data) {
  //httpClient.then(res => res?.data?.code === 400 ? router.push('/login') : null)
  let {
    raw = false,
    isAsync = false,
    data_model = null,
    loop = true,
    // external mean the base url is different
    external = false
  } = data;
  if (isAsync) return new Promise((resolve, reject) => {
    httpClient.then(res => {
      var _res$data, _res$data2, _res$data3, _res$data4, _res$data5, _res$data6, _res$data7;
      let responseDataData = res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data;
      (res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.code) === 200 ? data_model ? Array.isArray(res === null || res === void 0 || (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data) ? loop ? res === null || res === void 0 || (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.data.forEach(row => resolve({
        data: JsonMapper.isPrototypeOf(data_model) || JsonArrayMapper.isPrototypeOf(data_model) ? new data_model(row) : serializeObject(row, data_model)
      })) : resolve({
        data: res === null || res === void 0 || (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.data.map(row => JsonMapper.isPrototypeOf(data_model) || JsonArrayMapper.isPrototypeOf(data_model) ? new data_model(row) : serializeObject(row, data_model))
      }) : resolve({
        data: JsonMapper.isPrototypeOf(data_model) || JsonArrayMapper.isPrototypeOf(data_model) ? new data_model(responseDataData) : serializeObject(responseDataData, data_model),
        message: res === null || res === void 0 || (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.messages
      }) : resolve({
        data: raw ? res === null || res === void 0 ? void 0 : res.data : JsonMapper.isPrototypeOf(Response) || JsonArrayMapper.isPrototypeOf(Response) ? new Response(res === null || res === void 0 ? void 0 : res.data) : serializeObject(res === null || res === void 0 ? void 0 : res.data, Response)
      }) : external ? JsonMapper.isPrototypeOf(data_model) || JsonArrayMapper.isPrototypeOf(data_model) ? new data_model(res === null || res === void 0 ? void 0 : res.data) : serializeObject(res === null || res === void 0 ? void 0 : res.data, data_model) : reject({
        error: res === null || res === void 0 || (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.messages
      });
    }).catch(err => reject({
      error: err
    }));
  });
  this.OnStart = start => {
    getType(start) === 'Function' ? start() : null;
    return this;
  };
  this.OnSuccess = (success, model, loop = true) => {
    httpClient.then(res => {
      var _res$data8, _res$data9;
      let objectCode = res === null || res === void 0 || (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.code;
      let data = res === null || res === void 0 ? void 0 : res.data;
      let objectMessages = res === null || res === void 0 ? void 0 : res.data.messages;
      let objectData = res === null || res === void 0 || (_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.data;
      if (![200, 400].includes(objectCode)) {
        if (!external) return;
        return success(JsonMapper.isPrototypeOf(model) || JsonArrayMapper.isPrototypeOf(model) ? new model(data) : serializeObject(data, model));
      }
      if (objectCode === 400) {
        if (data.test) return;
        return store.dispatch('removeUserData').then(res => router.push(`/${i18n.locale}/login`));
      }
      if (!model) {
        return success(raw ? data : JsonMapper.isPrototypeOf(Response) || JsonArrayMapper.isPrototypeOf(Response) ? new Response(data) : serializeObject(data, Response), objectMessages);
      }
      if (Array.isArray(objectData)) {
        if (!loop) {
          return success(objectData.map(row => JsonMapper.isPrototypeOf(model) || JsonArrayMapper.isPrototypeOf(model) ? new model(row) : serializeObject(row, model)), objectMessages);
        }
        return objectData.forEach(row => success(JsonMapper.isPrototypeOf(model) || JsonArrayMapper.isPrototypeOf(model) ? new model(row) : serializeObject(row, model)));
      }
      success(JsonMapper.isPrototypeOf(model) || JsonArrayMapper.isPrototypeOf(model) ? new model(objectData) : serializeObject(objectData, model), objectMessages);
    });
    return this;
  };
  this.OnFailure = failure => {
    httpClient.then(res => {
      var _res$data10, _res$data11, _res$data12;
      return ![401, 200].includes(res === null || res === void 0 || (_res$data10 = res.data) === null || _res$data10 === void 0 ? void 0 : _res$data10.code) && res !== null && res !== void 0 && (_res$data11 = res.data) !== null && _res$data11 !== void 0 && _res$data11.code && !external ? failure(raw ? res === null || res === void 0 ? void 0 : res.data : res === null || res === void 0 || (_res$data12 = res.data) === null || _res$data12 === void 0 ? void 0 : _res$data12.messages) : null;
    }).catch(err => failure(err));
    return this;
  };
  this.OnValidationErrors = validation => {
    httpClient.then(res => {
      var _res$data13, _res$data14;
      return (res === null || res === void 0 || (_res$data13 = res.data) === null || _res$data13 === void 0 ? void 0 : _res$data13.code) === 401 && !external ? validation === null || validation === void 0 ? void 0 : validation(raw ? res === null || res === void 0 ? void 0 : res.data : res === null || res === void 0 || (_res$data14 = res.data) === null || _res$data14 === void 0 ? void 0 : _res$data14.messages) : null;
    });
    return this;
  };
  this.OnFinished = finished => {
    httpClient.then(() => finished()).catch(() => finished());
    return this;
  };
}
export default {
  sendApiRequest
};